import { UIKitIcon } from '../icon';

export const envelopeIcon: UIKitIcon = {
  name: 'envelope',
  // tslint:disable-next-line: max-line-length
  data: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><rect x="6" y="8" width="20" height="16" style="fill:inherit;'
  + 'stroke:inherit;stroke-linejoin:round"/><polyline points="18.5 16 26 24 6 24 13.5 16" style="fill:inherit;stroke:inherit;'
  + 'stroke-linejoin:round"/><polygon points="16 18 6 8 26 8 16 18" style="fill:inherit;stroke:inherit;stroke-linejoin:round"/></svg>',
};
